/* eslint-disable no-unused-expressions */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import config from '../../../config';

import RankingList from '../../RankingList';
import { fetchTopMenByTags, fetchTopWomenByTags } from '../../../redux/actions/top-ranked-actions';

const { appHost } = config;

class TopRankings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gender: 'm',
            activeLevel: props.initialActiveLevel || 'Pro',
            activeSubLevel: props.initialActiveSubLevel || null,
        };
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleGenderChange = this.handleGenderChange.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.handleShowAllClicked = this.handleShowAllClicked.bind(this);
    }

    componentDidMount() {
        this.fetchData();
    }

    getAnalyticsLabel(activeLevel, activeTab) {
        let label = '';
        switch (activeLevel) {
            case 1:
                label = 'U18';
                break;
            case 2:
                label = 'College';
                break;
            case 3:
                label = 'Pro';
                break;
            case 4:
                label = 'U16';
                break;
            case 5:
                label = 'U14';
                break;
            case 6:
                label = 'HighSchool';
                break;
            default:
                break;
        }
        switch (activeTab) {
            case 1:
                label = `${label} - men`;
                break;
            case 2:
                label = `${label} - women`;
                break;
            default:
                label = `${label} - men/women`;
                break;
        }
        return label;
    }

    handleShowAllClicked() {
        const levelDictionary = {
            U14: 5,
            U16: 4,
            U18: 1,
            HIGHSCHOOL: 6,
            COLLEGE: 2,
            PRO: 3,
        };
        const menShowAllLink = `/top-players?tab=1&level=${levelDictionary[this.state.activeLevel]}&sublevel=${this.state.activeSubLevel || ''}`;
        const womenShowAllLink = `/top-players?tab=2&level=${levelDictionary[this.state.activeLevel]}&sublevel=${this.state.activeSubLevel || ''}`;
        this.state.gender === 'm' ? window.location = `${appHost}/login?next=${encodeURIComponent(menShowAllLink)}` : window.location = `${appHost}/login?next=${encodeURIComponent(womenShowAllLink)}`;
    }

    fetchData() {
        if (this.state.activeSubLevel) {
            this.props.fetchTopMenByTags(null, this.state.activeSubLevel, this.props.fetchWithoutCount ? null : (this.props.fetchTop || 10));
            this.props.fetchTopWomenByTags(null, this.state.activeSubLevel, this.props.fetchWithoutCount ? null : (this.props.fetchTop || 10));
        } else {
            this.props.fetchTopMenByTags(this.state.activeLevel, null, this.props.fetchWithoutCount ? null : (this.props.fetchTop || 10));
            this.props.fetchTopWomenByTags(this.state.activeLevel, null, this.props.fetchWithoutCount ? null : (this.props.fetchTop || 10));
        }
    }

    handleGenderChange(gender) {
        this.setState({ gender });
    }

    handleTabChange(tabState) {
        const { selectedTab, selectedSubTab } = tabState;
        this.setState({ activeLevel: selectedTab.value, activeSubLevel: selectedSubTab && selectedSubTab.value }, this.fetchData);
    }

    findRanking(playerObject) {
        return playerObject.utrRanking;
    }

    findRating(playerObject) {
        return playerObject.utr;
    }

    render() {
        const { hideTitle, className, topRanked /* , featureFlags */ } = this.props;
        const { gender, activeLevel } = this.state;
        const tabOptions = {
            tabs: [
                {
                    name: 'U14',
                    value: 'U14',
                },
                {
                    name: 'U16',
                    value: 'U16',
                },
                {
                    name: 'U18',
                    value: 'U18',
                },
                {
                    name: 'HIGH SCHOOL',
                    value: 'HighSchool',
                    subTabs: [
                        {
                            name: 'TEXAS',
                            value: 'texas',
                        },
                        {
                            name: 'CIF-SDS',
                            value: 'cifsd',
                        },
                    ],
                    subTabLink: {
                        linkValue: '/high-school',
                        linkName: 'Want to see your state or section listed?',
                    },
                },
                {
                    name: 'COLLEGE',
                    value: 'College',
                },
                {
                    name: 'PRO',
                    value: 'Pro',
                    default: true,
                },
            ],
        };

        const { men, women } = topRanked;
        return (
            <RankingList
                tabOptions={tabOptions}
                title={'Player Spotlight'}
                className={className}
                onTabChanged={this.handleTabChange}
                onGenderChanged={this.handleGenderChange}
                players={gender === 'm' ? men.players : women.players}
                displayCount={5}
                gender={gender}
                hideTitle={hideTitle}
                ranking={(playerObj) => this.findRanking(playerObj)}
                rating={(playerObj) => this.findRating(playerObj)}
                loading={gender === 'm' ? men.isLoading : women.isLoading}
                showGetRated={true}
                playerLevel={activeLevel}
                showThirdPartyRanking={activeLevel === 'Pro'}
                onShowAllClicked={this.handleShowAllClicked}
                footerTitle={'Show All'}
            />
        );
    }
}

function mapStateToProps({ topRanked }) {
    return { topRanked };
}

export default connect(mapStateToProps, { fetchTopMenByTags, fetchTopWomenByTags })(TopRankings);
